<template>
    <div>
        <p>Sign-in in progress</p>
    </div>
</template>

<script>
const DEFAULT_ROUTE = '/account/main';
export default {
    name: 'OauthCallback',
    async created() {
        try {
            const result = await this.$root.securityService.signinRedirectCallback();
            let path = result.state.path;
            let returnToUrl = path === undefined 
                || this.$router.resolve(path).route.name === this.$route.name
                ? DEFAULT_ROUTE
                : path;
            
            this.$router.replace({ path: returnToUrl });
        } catch (e) {
            console.warn('Unable to handle signing redirect callback', e);
            this.$router.replace({ path: DEFAULT_ROUTE });
        }
    },
};
</script>
